import axios from 'axios'
import qs from 'qs'
import { util, Constant, Env } from '../assets/js/util'

var preview = util.getUrlParam('preview') || 0
var pannochoose = util.getUrlParam('choose') || 0
var appType = ''
if (location.hash.indexOf('/huangye') > -1) { // 黄页
  appType = 'huangye'
} else if (location.hash.indexOf('/entity') > -1) { // 实体
  appType = 'entity'
} else if (location.hash.indexOf('/hotel') > -1) { // 酒店
  appType = 'hotel'
} else if (location.hash.indexOf('/album') > -1) { // 相册
  appType = 'album'
}

// 路径参数可以强制更改进入哪个逻辑（废弃）
// switch (util.getUrlParam('path')) {
//   case 'entity':
//     appType = 'entity'
//     break
//   case 'hotel':
//     appType = 'hotel'
//     break
//   case 'album':
//     appType = 'album'
//     break
//   case 'huangye':
//     appType = 'huangye'
//     break
// }

var interceptor = {
  success (res) { return res },
  error (err) {
    util.showToast('服务错误，请稍后重试')
    // loadingInstance.close()
    console.log(err)
  }
}

// 默认接口头部域名
axios.defaults.baseURL = Env().queryUrl
axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.interceptors.response.use(interceptor.success, interceptor.error)

/* *
 * axios默认发送post请求方式为application/json
 * 若需要使用 application/x-www-form-urlencoded 格式发送
 * 需要把参数通过qs转成字符串
 * This is only applicable for request methods 'PUT', 'POST', and 'PATCH'
 */
axios.defaults.transformRequest = [
  function (data) {
    var params = qs.stringify(data)
    return params
  }
]

/* *
 * 添加vue全局插件api
 * 通过添加Vue实例方法，调用：vm.$api
 */
export default {
  install (Vue) {
    Vue.prototype.$api = {
      // 是否为白名单
      isWhite (creatorId) {
        return axios.get('/api/app/white/' + creatorId)
      },
      // 获取活动
      getActivityById (id) {
        return axios.get('/api/app/activity/' + id)
      },
      // 获取设施分组
      // getFacilityGroup (entityId) {
      //   return axios.get('/api/app/farm/pano/V2' + entityId, {params: {preview: preview}})
      // },
      // 应用信息
      // getAppInfoOld (appId) {
      //   return axios.get('/api/app/' + appId)
      // },
      // 应用信息
      getAppInfo (appId) {
        return axios.get('/api/app/V2/' + appId)
      },
      // 应用下实体列表
      // getEntityListOld (appId) {
      //   return axios.get('/api/app/entity/list/' + appId, {params: {preview: preview}})
      // },
      // 应用下实体列表
      getEntityList (appId) {
        return axios.get(`/api/app/entity/list/V3/${appId}/${0}`)
      },
      // hotel应用下实体列表
      // getHotelEntityList (appId) {
      //   return axios.get('/api/app/hotel/distribution', {params: {appId: appId, preview: preview}})
      // },
      // 实体信息
      getEntityInfo (entityId) {
        return axios.get('/api/app/entity/' + entityId)
      },
      // poi详情
      // getPoiDetail (urlPlugin) {
      //   return axios.get(Env.lunaUrl + '/luna-web/api/poi/' + urlPlugin)
      // },
      // 实体周边实体
      // getSurroundEntity (entityId) {
      //   return axios.get('/api/surround/entity', {params: {entityId: entityId, preview: preview}})
      // },
      // 实体周边poi
      // getSurroundPoi (paramsData) {
      //   return axios.get('/api/surround', {params: {appId: paramsData.appId, entityId: paramsData.entityId, preview: preview}})
      // },
      // 实体的子实体
      // getSubEntity (entityId) {
      //   return axios.get('/api/app/entity/subEntitys', {params: {entityId: entityId, preview: preview}})
      // },
      // 实体外观
      // getAppearance (entityId) {
      //   return axios.get('/api/app/entity/appearance', {params: {entityId: entityId, preview: preview}})
      // },
      // 实体设施
      // getFacility (entityId) {
      //   if (appType === 'album') {
      //     return axios.get('/api/app/album/facility', {params: {entityId: entityId, preview: preview}})
      //   } else {
      //     return axios.get('/api/app/facility/list', {params: {facilityId: 0, entityId: entityId, preview: preview}})
      //   }
      // },
      // 模型实体信息
      // getModelFacility (entityId) {
      //   return axios.get('/api/app/r3d/facility', {params: {entityId: entityId, preview: preview}})
      // },
      // 根据设施id获取三维模型信息
      // getModelInfoOld (facilityId) {
      //   return axios.get('/api/app/r3d/facility/' + facilityId, {params: {preview: preview}})
      // },
      // 根据设施id获取三维模型信息
      getModelInfo (facilityId) {
        return axios.get('/api/app/r3d/facility/V2/' + facilityId, {params: {preview: preview}})
      },
      // 获取模型信息
      getModelDetail (params) {
        // return axios.get(`/3d/model/${params}`)
        return axios.get(`/api/vbr3d/${params}`)
      },
      // 设施信息
      getFacilityInfo (entityId) {
        if (appType === 'hotel') {
          return axios.get('/api/app/hotel/facility/' + entityId, {params: {preview: preview}})
        } else {
          return axios.get('/api/app/facility/V2/' + entityId, {params: {preview: preview}})
        }
      },
      // 根据设施id获取全景信息
      // getPanoInfoOld (facilityId) {
      //   return axios.get('/api/app/album/facility/' + facilityId, {params: {preview: preview}})
      // },
      // 根据设施id获取全景信息
      getPanoInfo (facilityId) {
        return axios.get('/api/app/album/facility/V2/' + facilityId, {params: {preview: preview}})
      },
      // 全景及marker信息
      getPanoMarker (paramsData) {
        return axios.get('/api/app/facility/marker', {params: {facilityId: paramsData.facilityId, materialId: paramsData.materialId, preview: preview}})
      },
      // 获得摄影师作品集
      // getPhotograherWorks (photographerId) {
      //   return axios.get('/api/app/photographer/' + photographerId, {params: {preview: preview}})
      // },
      getPhotograherInfo (photographerId) {
        return axios.get('/api/app/photographer/profileExt/' + photographerId, {params: {preview: preview}})
      },
      // 根据分组id获取该分组设施
      getFacilityByGroup (paramsData) {
        return axios.get(`/api/app/album/facility/byGroup/V2/${paramsData.entityId}/${paramsData.groupId || ''}`, {params: {preview: preview}})
      },
      // 绑定微博
      bindWeibo (code) {
        let redirectUri = Constant.ShareUrl.replace(/&/g, '%26')
        return axios.put('/api/user/weiboBinding', {params: {code: code, redirectUri: redirectUri}})
      },
      // 获取微博token
      getWeiboToken (code) {
        let redirectUri = Constant.ShareUrl.replace(/&/g, '%26')
        return axios.get('/api/user/getToken', {params: {code: code, redirectUri: redirectUri}})
      },
      // 分享全景到微博
      sharePanoToWeibo (paramsData) {
        return axios.post('/api/weibo/sharePano', paramsData)
      },
      // 获取三维marker上三维的调轴信息
      // get3dInfoByMaterialId (materialId) {
      //   return axios.get('/api/vbr3d/' + materialId)
      // },
      // 获取marker点赞数和浏览数
      getLikeAndWatchNum (markerId) {
        return axios.get('/api/app/marker/actionsCount', {params: {markerId: markerId}})
      },
      // 点赞
      setLike (paramsData) {
        return axios.post('/api/app/marker/thumbUp', paramsData)
      },
      // 设置浏览
      setWatch (markerId) {
        return axios.get('/api/app/marker/browse', {params: {markerId: markerId}})
      },
      setPanoMta (paramsData) {
        return axios.post('/api/app/newEvent', paramsData)
      },
      getAppListInfo (appId) {
        // console.log(pannochoose)
        return axios.get('/api/app/info/' + appId, { params: { preview: preview } })
      },
      // 返回url参数
      returnparam () {
        return pannochoose
      },
      // 获取应用点赞数 观看人数
      getAppZanNum (appId) {
        return axios.get('/api/app/actionsCount', {params: {appId: appId}})
      },
      // 用户浏览计数  无返回数据,每执行一次,数据库该markerId对应的浏览次数(visitCount )＋1
      visitCount (params) {
        return axios.get(`/api/app/browse?appId=${params.appId}`, {params})
      },
      // 点赞+1 无返回数据,每执行一次,数据库该appId对应的点赞次数(thumbUpCount )+1
      thumbUpCount (params) {
        return axios.post(`/api/app/thumbUp?appId=${params.appId}`, params)
      },
      // 获取今天是否点击过赞 一天只能点赞一次 点击后不能取消
      getThumbUpStatus (params) {
        return axios.get(`/api/app/thumbUpStatus?appId=${params.appId}`, {params})
      },
      // getVizenEntityInfo (entityId) {
      //   return axios.get('/api/app/vizenEntity/' + entityId)
      // },
      getEntityStructure (entityId) {
        return axios.get('/api/app/entity/framework/' + entityId)
      },
      getHotelService () {
        return axios.get('/common/options/hotelService')
      },
      getEquipOptions () {
        return axios.get('/common/options/hotelEquipment')
      },
      getEntitySurround (paramsData) {
        return axios.get(`/api/app/entity/surrounds/V2/${paramsData.pEntityId}/${paramsData.entityId}`)
      },
      getEntitySurroundInfo (paramsData) {
        return axios.get(`/api/app/entity/entities/V2/${paramsData.ids}/${paramsData.entityId || ''}`)
      },
      // 1902170410 故宫相册限定
      getAlbumMta (appId) {
        return axios.get('/api/app/getAppMtaStat', {params: {appId: appId}})
      },
      getAllInfoMarker (appId) {
        return axios.get('/api/app/marker/all?appId=' + appId)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js